import '../../monitoring/filters/keyword/keywords_filter_view.js.coffee'

Namespace 'Profiling.Dashboard.Filters'

class Profiling.Dashboard.Filters.KeywordsFilterView extends Monitoring.Views.SocialContents.Filters.KeywordsFilterView
  _triggerQueryChanged: =>
    @searchQuery.triggerFilterChanged()
